import { type ProductBrief, type ProductSimple } from '@/domain/products/types';
import { SuccessToast } from '@/features/cart/components';
import { addToCart } from '@/features/cart/store/cart';
import { Tooltip } from '@andritzot/metris-web-ui/data-display/tooltip';
import { IconButton } from '@andritzot/metris-web-ui/inputs/icon-button';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { AddShoppingCartOutlined } from '@mui/icons-material';
import { usePiwikPro } from '@piwikpro/next-piwik-pro';
import { type MouseEvent } from 'react';
import { toast } from 'react-toastify';

interface AddToCartButtonProps {
  product: ProductSimple | ProductBrief;
  isInCart: boolean;
  isSelected?: boolean;
}

const AddToCartButton = ({ product, isInCart, isSelected = false }: AddToCartButtonProps) => {
  const disabled = isInCart;
  const { eCommerce } = usePiwikPro();

  const handleAddToCart = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation(); // avoid opening modal
    eCommerce.ecommerceAddToCart([
      {
        sku: `${product.idProduct}`,
        name: product.product,
        category: ['group' in product ? product.group.productGroup : ''],
        price: 0,
        quantity: 1,
      },
    ]);
    addToCart({
      idProduct: product.idProduct,
      image2: product.image2,
      product: product.product,
      group: 'group' in product ? product.group.productGroup : '',
      documentation: product.documentation,
    });
    toast.success(<SuccessToast title={product.product} />, { autoClose: 5000 });
  };

  return (
    <Box sx={{ color: isSelected ? 'primary.contrastText' : 'primary' }}>
      <Tooltip title={disabled ? 'Product already in cart' : 'Add product to cart'} placement="top">
        {/* span keeps the tooltip hoverable while the button is disabled */}
        <span>
          <IconButton
            variant="outlined"
            disabled={disabled}
            onClick={handleAddToCart}
            color={isSelected ? 'inherit' : 'primary'}
          >
            <AddShoppingCartOutlined />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default AddToCartButton;
